import Vue from 'vue'
import store from 'store'
import Router from 'vue-router'
import * as UserManager from '../SDK/UserManager'
import Login from '@/page/login/login'
import SecondaryCertification from '@/page/secondary-certification/secondary-certification'
import * as Util from 'util'

Vue.use(Router)

// 异步写法如下
// const ent = resolve => require(['@/page/ent/ent'], resolve)
// const myshare = resolve => require(['@/page/myshare/myshare'], resolve)
// const sharetome = resolve => require(['@/page/sharetome/sharetome'], resolve)
// const self = resolve => require(['@/page/self/self'], resolve)
// const favorite = resolve => require(['@/page/favorite/favorite'], resolve)
// const setting = resolve => require(['@/page/setting/setting'], resolve)
const NotFoundComponent = (resolve) =>
  require(['@/page/error/error_404'], resolve)
const channel = (resolve) => require(['@/page/channel/channel'], resolve)
// const comments = resolve => require(['@/components/filelist/filelist_comment'], resolve)
// const fileDetail = resolve => require(['@/components/filelist/filelist_file_detail'], resolve)
// const history = resolve => require(['@/components/filelist/filelist_history'], resolve)
// const movecopy = resolve => require(['@/components/movecopy/movecopy'], resolve)
// const delivery = resolve => require(['@/components/delivery/delivery'], resolve)
// const message = resolve => require(['@/components/message/message'], resolve)
// const previewDoc = resolve => require(['@/components/preview/preview_doc'], resolve)
// const deliveryTransfor = resolve => require(['@/components/delivery/delivery_transfor'], resolve)
const routes = [
  // {
  //   path: '/self',
  //   name: 'self',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: self
  // },
  // {
  //   path: '/myshare',
  //   name: 'myshare',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: myshare
  // },
  // {
  //   path: '/sharetome',
  //   name: 'sharetome',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: sharetome
  // },
  // {
  //   path: '/favorite',
  //   name: 'favorite',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: favorite
  // },
  {
    path: '/login',
    component: Login,
    meta: {
      isLogin: true
    }
  },
  {
    path: '/secondary-certification',
    component: SecondaryCertification,
    meta: {
      isLogin: true
    }
  },
  {
    path: '/',
    meta: {
      requireAuth: true
    },
    component: channel
  },
  // {
  //   path: '/ent',
  //   name: 'ent',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: ent
  // },
  // {
  //   path: '/comments',
  //   name: 'comments',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: comments
  // },
  // {
  //   path: '/setting',
  //   name: 'setting',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: setting
  // },
  // {
  //   path: '/delivery',
  //   name: 'delivery',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: delivery
  // },
  // {
  //   path: '/fileDetail',
  //   name: 'fileDetail',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: fileDetail
  // },
  // {
  //   path: '/history',
  //   name: 'history',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: history
  // },
  // {
  //   path: '/movecopy',
  //   name: 'movecopy',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: movecopy
  // },
  // {
  //   path: '/message',
  //   name: 'message',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: message
  // },
  // {
  //   path: '/preview_doc',
  //   name: 'preview_doc',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: previewDoc
  // },
  // {
  //   path: '/deliveryTransfor',
  //   name: 'deliveryTransfor',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: deliveryTransfor
  // },
  {
    path: '*',
    component: NotFoundComponent
  }
]

// 页面刷新时，重新赋值token
if (window.localStorage.getItem('userInfo')) {
  // console.log(JSON.parse(window.localStorage.getItem('userInfo')))
  store.commit('login', JSON.parse(window.localStorage.getItem('userInfo')))
}

const router = new Router({
  // mode: 'history',
  routes
})

// 接收需要转存的外链缓存数据
var linkStorage = window.localStorage.getItem('linkInfo')
var linkUrl = window.localStorage.getItem('linkUrl')
store.state.linkInfo = JSON.parse(linkStorage)

/* let oauth = getQueryString('oauth')
let url = encodeURI('https://box.yst.com.cn/v2/weixin/user/login')
if (oauth) {
  // location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww5358bdb3655ef228&redirect_uri=' + url + '&response_type=code&scope=snsapi_base&agentid=1000013&state=cloud#wechat_redirect'
  location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8a913347adfbce28&redirect_uri=' + url + '&response_type=code&scope=snsapi_base&agentid=1000016&state=cloud#wechat_redirect'
} */

function setTitle () {
  const title = sessionStorage.getItem('title')
  if (title) {
    document.title = title
    return
  }
  const customParams = {
    config_type: 0,
    config_id: 0,
    name: 'custom_product_zh_name'
  }
  UserManager.configGet(customParams).then(res => {
    const title = res[0].value
    document.title = title
    sessionStorage.setItem('title', title)
  })
}

router.beforeEach((to, from, next) => {
  const title = document.title
  if (!title) {
    setTitle()
  }
  if (to.path === '/login' || to.path === '/secondary-certification') {
    checkSession(function (response) {
      if (response.user_id) {
        if (linkStorage) {
          next({
            path: '/deliveryTransfor'
          })
        } else if (linkUrl) {
          window.location.href = linkUrl
        } else {
          next({
            path: '/'
          })
        }
      } else {
        next()
      }
    })
  } else {
    checkSession(function (response) {
      if (response.user_id) {
        store.state.userInfo = response
        if (to.matched.some((r) => r.meta.requireAuth)) {
          const sessionid = Util.getCookie('X-LENOVO-SESS-ID')
          if (sessionid) {
            store.state.userInfo['X-LENOVO-SESS-ID'] = sessionid
            if (linkStorage && to.path !== '/deliveryTransfor') {
              next({
                path: '/deliveryTransfor'
              })
            } else if (linkStorage && to.path === '/deliveryTransfor') {
              next()
            } else {
              next()
            }
          } else {
            console.log('验证异常')
          }
        }
      } else if (
        (response.data && response.data.state === 401) ||
        response.state !== 200
      ) {
        console.log('登录异常！！！！')
        // 内置浏览器通过手机浏览器打开，存储短链，以免丢失
        const linkFileReference = to.query && to.query.linkFileReference
        if (linkFileReference) {
          window.localStorage.setItem('linkFileReference', linkFileReference)
        }
        next({
          path: '/login'
        })
      } else {
        next({
          path: '/login'
        })
      }
    })
  }
})

function checkSession (callback) {
  const sessionid = Util.getCookie('X-LENOVO-SESS-ID')
  UserManager.getInfoByCookie({ token: sessionid }).then(
    (response) => {
      callback(response)
    },
    (error) => {
      console.log(error)
    }
  )
}

/* function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r !== null) return unescape(r[2])
  return null
} */

export default router



// WEBPACK FOOTER //
// ./src/router/router.js